import { getMedplumErrorIssueCodes, isMedplumHttpError } from "@/utils/medplum-http-error";

/** OperationOutcome issue codes that mean the access policy refused the request. */
const FORBIDDEN_ISSUE_CODES = new Set(["forbidden", "security"]);

/**
 * Detects Medplum / FHIR client errors that represent HTTP 403 Forbidden, including wrapped fetch shapes
 * and OperationOutcomes whose issue code is `forbidden` or `security`.
 */
export function isMedplumForbiddenError(error: unknown): boolean {
  return (
    isMedplumHttpError(error, 403, "forbidden") ||
    getMedplumErrorIssueCodes(error).some((code) => FORBIDDEN_ISSUE_CODES.has(code))
  );
}

/**
 * Detects Medplum / FHIR client errors that represent HTTP 404 Not Found, including wrapped fetch shapes.
 */
export function isMedplumNotFoundError(error: unknown): boolean {
  return isMedplumHttpError(error, 404, "not found");
}
